import React from "react";
import { Navigate } from "react-router-dom";
import { useUserContext } from "../modules/user/UserContext";

interface ProtectedRouteProps {
  element: JSX.Element;
  adminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, adminOnly = false }) => {
  const token = localStorage.getItem("authToken");
  const { isAdmin } = useUserContext();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/dash" replace />;
  }

  return element;
};

export default ProtectedRoute;
